import React, {useEffect, useState} from 'react';
import './LikertForm.sass';
import apiJSON from "../../../api/apiJSON";
import Button from "../../ui/Button/Button";
import CheckMark from "../../../icons/fat_check.svg"
import StandardButton from "../../ui/Button/StandardButton";

const LikertForm = ({data, completed, next}) => {

    const [tracking, setTracking] = useState(null);
    const [finished,setFinished] = useState(false);
    const jsonData = apiJSON.get(data);
    const {scenario} = jsonData

    useEffect(() => {
        let t = [];
        scenario.choiceSets.map((cs, index) => {
            t[index] = -1;
        });
        setTracking(t)
    }, []);

    const handleSelect = (questionIndex, choiceIndex) => {
        updateTracking(questionIndex, choiceIndex);
    }

    const updateTracking = (questionIndex, choiceIndex) => {
        let t = tracking.slice();
        t[questionIndex] = choiceIndex;
        setTracking(t);
        if(t.indexOf(-1)===-1){
            setFinished(true);
            completed();
        }
    }

    const handlePrint = () =>{
        window.print();
    }

    return (
        <div className="LikertForm">
            <div className="likert-header">
                <div className="likert-header-title">
                    {scenario.title}
                </div>
                <div className="likert-header-body">
                    {scenario.body}
                </div>
            </div>
            <div className="likert-form-holder">
                <div className="likert-question-row no-border">
                    <div className="likert-question">
                        {}
                    </div>
                    <div className="likert-button-row">
                        {scenario.scale.map((c, i) => (
                            <div className="likert-label"
                                 key={"label-holder" + i}>
                                {c.label}
                            </div>
                        ))
                        }
                    </div>
                </div>
                <div>
                    {scenario.choiceSets &&
                    scenario.choiceSets.map((cs, index) => (
                        <div className={"likert-question-row" + ((index === scenario.choiceSets.length - 1) ? " no-border" : "")}
                             key={"question" + index}>
                            <div className="likert-question">
                                {cs.label}
                            </div>
                            <div className="likert-button-row">
                                {
                                    scenario.scale.map((c, i) => (
                                        <div className={"likert-button-holder"}
                                             key={"button-holder" + index + "_" + i}>
                                            <div className={"likert-button" + ((tracking && tracking[index] === i) ? " selected" : "")}
                                                 key={"button" + index + "_" + i}
                                                 onClick={() => handleSelect(index, i)}>
                                                {(tracking && tracking[index] === i)&&<img src={CheckMark}/>}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                    }
                </div>
            </div>
            <div className="likert-controls-row">
                <StandardButton data={"DONE"} callback={()=>next()} disabled={!finished}/>
                <StandardButton data={"PRINT"} callback={handlePrint} disabled={!finished}/>
            </div>
        </div>
    );
}

export default LikertForm;